import { Autocomplete, FormHelperText, Grid, TextField } from '@mui/material'
import { DesktopDateTimePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import TinyRichEditor from '../../../../../shared/components/TinyRichEditor'
import { NotificationsSection } from './NotificationsSection'

interface GeneralTabProps {
  seminarLessonState: any
  errorForm: any
  msgForm: any
  handleDateTimeChange: (newValue: Dayjs | null) => void
  handleTypeChange: (value: any) => void
  handleContentChange: (value: string) => void
  handleExtraContentChange: (value: string) => void
  handleNotificationsChange: (inputName: string) => (event: any) => void
  handleInputChange: (inputName: string, value: any) => void
}

const types = [
  { id: 0, name: 'Embed' },
  { id: 1, name: 'Vimeo' }
]

export const GeneralTab = ({
  seminarLessonState,
  errorForm,
  msgForm,
  handleDateTimeChange,
  handleTypeChange,
  handleContentChange,
  handleExtraContentChange,
  handleNotificationsChange,
  handleInputChange
}: GeneralTabProps) => {
  const { t } = useTranslation(['global'])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={seminarLessonState.type === 1 ? 3 : 6}>
        <DesktopDateTimePicker
          label="Fecha y hora"
          value={seminarLessonState.datetime ? dayjs(seminarLessonState.datetime) : null}
          onChange={handleDateTimeChange}
          slotProps={{ textField: { fullWidth: true } }}
        />
      </Grid>

      <Grid item xs={12} md={seminarLessonState.type === 1 ? 3 : 6}>
        <Autocomplete
          id="combo-box-types"
          disableClearable
          value={types.find((type: any) => type.id === seminarLessonState.type)}
          options={types}
          onChange={(_event, value) => handleTypeChange(value)}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
          renderInput={params => <TextField {...params} label={t('type')} variant="filled" InputLabelProps={{ shrink: true }} />}
        />
      </Grid>

      {seminarLessonState.type === 0 ? (
        <Grid item xs={12}>
          <TinyRichEditor handleInputChange={handleInputChange} value={seminarLessonState.content} uploadURL="/seminarlessons/upload" />
          <FormHelperText error={errorForm.content}>{msgForm.content}</FormHelperText>
        </Grid>
      ) : (
        <>
          <Grid item xs={12} sm={3} md={3}>
            <TextField
              data-createseminarlesson="content"
              label={`${t('link')} ${t('video')}`}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="filled"
              value={seminarLessonState.content}
              onChange={event => handleContentChange(event.target.value)}
            />
            <FormHelperText error={errorForm.videolink}>{msgForm.videolink}</FormHelperText>
          </Grid>

          <Grid item xs={12} sm={3} md={3}>
            <TextField
              data-createseminarlesson="extracontent"
              label={`${t('link')} ${t('chat')}`}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              variant="filled"
              value={seminarLessonState.extracontent}
              onChange={event => handleExtraContentChange(event.target.value)}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12} sm={3} md={3}>
        <NotificationsSection notifications={seminarLessonState.notifications} handleNotificationsChange={handleNotificationsChange} />
      </Grid>
    </Grid>
  )
}
